import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Utils/AxiosInstance";
import { revertAll } from "../../ResetStateAction";

const initialState = {
  CommissionHeads: [],
  GenerateCommissions: [],
  CommissionTemplates: [],
  HeadingPopulate: [],
  CommissionTemplatePopulate: [],
  LeadsGenerateCommissions: [],
  TemplateVerification: [],
  PayCommission: [],
  HeadingUserPopulate: [],
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  IsLogin: true,
};
export const fetchCommissionHeads = createAsyncThunk("/CommissionHeads", async () => {
  const response = await axiosInstance.get(`/CommissionHeadings`);
  return response.data;
});
export const fetchCommissionTemplates = createAsyncThunk("/CommissionTemplates", async () => {
  const response = await axiosInstance.get(`/CommissionTemplate/getalltemplates`);
  return response.data;
});
export const fetchHeadingPopulate = createAsyncThunk("/HeadingPopulate", async () => {
  const response = await axiosInstance.get(`/CommissionHeadings/populate`);
  return response.data;
});
export const fetchHeadingUserPopulate = createAsyncThunk("/HeadingUserPopulate", async () => {
  const response = await axiosInstance.get(`CommissionHeadings/PopulateHeadUsers`);
  return response.data;
});

export const fetchGenerateCommissions = createAsyncThunk("/GenerateCommissions", async () => {
  const response = await axiosInstance.get(`/Commission`);
  return response.data;
});
export const fetchLeadsGenerateCommissions = createAsyncThunk("/LeadGenerateCommissions", async () => {
  const response = await axiosInstance.get(`/CommissionTemplate/leadsgeneratingcommission`);
  return response.data;
});
export const fetchCommissionTemplatePopulate = createAsyncThunk("/CommissionTemplatePopulate", async () => {
  const response = await axiosInstance.get(`/CommissionTemplate/populate`);
  return response.data;
});
export const fetchCommissionTemplateVerification = createAsyncThunk(
  "/TemplateVerification",
  async ({ tempid, leadid }) => {
    const response = await axiosInstance.get(`/CommissionTemplate/templateverify?tempid=${tempid}&leadid=${leadid}`);
    return response;
  }
);
export const fetchPayCommission = createAsyncThunk("/PayCommission", async () => {
  const response = await axiosInstance.get(`/CommissionTemplate/GetLeadCommisisons`);
  return response.data;
});
const CommissionSettingsSlice = createSlice({
  name: "CommissionHeads",
  initialState,
  reducers: {
    CommissionHeadsAdded: {
      reducer(state, action) {
        state.CommissionHeads?.push(action.payload);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchGenerateCommissions.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchGenerateCommissions.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.GenerateCommissions = action.payload.Data;
      })
      .addCase(fetchGenerateCommissions.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchCommissionHeads.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchCommissionHeads.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.CommissionHeads = action.payload.Data;
      })
      .addCase(fetchCommissionHeads.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchCommissionTemplates.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchCommissionTemplates.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.CommissionTemplates = action.payload.Data;
      })
      .addCase(fetchCommissionTemplates.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchHeadingPopulate.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchHeadingPopulate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.HeadingPopulate = action.payload.Data;
      })
      .addCase(fetchHeadingPopulate.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchHeadingUserPopulate.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchHeadingUserPopulate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.HeadingUserPopulate = action.payload.data;
      })
      .addCase(fetchHeadingUserPopulate.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchLeadsGenerateCommissions.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchLeadsGenerateCommissions.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.LeadsGenerateCommissions = action.payload.Data;
      })
      .addCase(fetchLeadsGenerateCommissions.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchCommissionTemplatePopulate.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchCommissionTemplatePopulate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.CommissionTemplatePopulate = action.payload.Data;
      })
      .addCase(fetchCommissionTemplatePopulate.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchCommissionTemplateVerification.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchCommissionTemplateVerification.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.TemplateVerification = action.payload.data;
      })
      .addCase(fetchCommissionTemplateVerification.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchPayCommission.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchPayCommission.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.PayCommission = action.payload.data;
      })
      .addCase(fetchPayCommission.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const getCommissionSettings = state => state.CommissionHeads;

export const { CommissionHeadsAdded } = CommissionSettingsSlice.actions;

export default CommissionSettingsSlice.reducer;
